import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useNordyWorkflowApiPromptStore = defineStore(
  'nordyWorkflowApiPrompt',
  () => {
    const workflowApiPrompt = ref<string | null>(null)
    const fakeJobRunning = ref<boolean>(false)

    const setWorkflowApiPrompt = (prompt: string | null) => {
      workflowApiPrompt.value = prompt
    }

    const setFakeJobRunning = (running: boolean) => {
      fakeJobRunning.value = running
    }

    const getWorkflowApiPrompt = () => {
      return workflowApiPrompt.value
    }

    const getFakeJobRunning = () => {
      return fakeJobRunning.value
    }

    return {
      setWorkflowApiPrompt,
      getWorkflowApiPrompt,
      setFakeJobRunning,
      getFakeJobRunning
    }
  }
)
